import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Col, Container, Nav, Row, Tab, Figure, Badge, Card } from 'react-bootstrap';

import { toggleCollapsedNav } from '../redux/action/Theme';

import DashboardSummaryInfo from './dashboard/DashboardSummaryInfo';
import DashboardMultiLineChart from './dashboard/DashboardMultiLineChart';
import DashboardPieChart from './dashboard/DashboardPieChart';
import DashboardDoughnutChart from './dashboard/DashboardDoughnutChart';
// import DashboardPieChart2 from './dashboard/DashboardPieChart2';
import DashboardInfoSummaryBox from './dashboard/DashboardInfoSummaryBox';
import DashboardGroupHorizontalBarChart from './dashboard/DashboardGroupHorizontalBarChart';
import DashboardBarChartHorizontal from './dashboard/DashboardBarChartHorizontal';
import DashboardGoogleMap from './dashboard/DashboardGoogleMap';

import DashboardListGroup from './dashboard/DashboardListGroup';

import CommonTokenExpired from './components/CommonTokenExpired';

import * as Actions from './actions/ActionCenter';

import * as charts from '../library/charts';

import DataTableDashboardSecABudget from './dataTables/DataTableDashboardSecABudget';
import DataTableDashboardSecATrainee from './dataTables/DataTableDashboardSecATrainee';
import DataTableDashboardSecABudgetIndustries from './dataTables/DataTableDashboardSecABudgetIndustries';
import DataTableDashboardSecAIndustries from './dataTables/DataTableDashboardSecAIndustries';
import DataTableDashboardSecBCourseList from './dataTables/DataTableDashboardSecBCourseList';
import DataTableDashboardBilateral from './dataTables/DataTableDashboardBilateral';
import DataTableDashboardTypeA from './dataTables/DataTableDashboardTypeA';
import DataTableDashboardCustom from './dataTables/DataTableDashboardCustom';
import DashboardVerticalBarChart from './dashboard/DashboardVerticalBarChart';
import CommonSelect from './components/CommonSelect';

const usersTypesMap = {
    1: {
        label: 'ADMIN SYSTEM',
        icon: 'fa-classic fa-light fa-user-astronaut fa-fw'
    },
    2: {
        label: 'USER EDU',
        icon: 'fa-classic fa-light fa-graduation-cap fa-fw'
    },
    3: {
        label: 'USER ENT',
        icon: 'fa-classic fa-light fa-user-graduate fa-fw'
    },
    4: {
        label: 'EXTERNAL USER',
        icon: 'fa-classic fa-light fa-users fa-fw'
    }
};

    /*
        const mockData1 = {
            rows: [
                {
                    type: "นักศึกษาเข้าใหม่",
                    educationLevel: 1,
                    faculty: null,
                    industry: "อุตสาหกรรมยานยนต์",
                    count: 120
                },
                {
                    type: "นักศึกษาเข้าใหม่",
                    educationLevel: 1,
                    faculty: null,
                    industry: "อุตสาหกรรมอิเล็กทรอนิกส์",
                    count: 80
                },
                {
                    type: "นักศึกษาเข้าใหม่",
                    educationLevel: 2,
                    faculty: null,
                    industry: "อุตสาหกรรมดิจิทัล",
                    count: 60
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 1,
                    faculty: "ช่างยนต์",
                    industry: "อุตสาหกรรมยานยนต์",
                    count: 45
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 1,
                    faculty: "ช่างไฟฟ้า",
                    industry: "อุตสาหกรรมอิเล็กทรอนิกส์",
                    count: 30
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 2,
                    faculty: "เทคโนโลยีสารสนเทศ",
                    industry: "อุตสาหกรรมดิจิทัล",
                    count: 55
                }
            ],
            page: 1,
            pageSize: 10,
            totalRows: 6
        };
    */

const groupedByLevelData = {
    labels: [
        "อุตสาหกรรมยานยนต์",
        "อุตสาหกรรมอิเล็กทรอนิกส์",
        "อุตสาหกรรมดิจิทัล"
    ],
    datasets: [
        {
            label: "ปวช",
            data: [165, 110, 40]
        },
        {
            label: "ปวส",
            data: [45, 30, 75]
        }
    ]
};

const graduateFacultyIndustryData = {
    labels: [
        "อุตสาหกรรมยานยนต์",
        "อุตสาหกรรมอิเล็กทรอนิกส์",
        "อุตสาหกรรมดิจิทัล"
    ],
    datasets: [
        {
            label: "ช่างยนต์",
            data: [40, 20, 30]
        },
        {
            label: "ช่างไฟฟ้า",
            data: [60, 30, 70]
        },
        {
            label: "เทคโนโลยีสารสนเทศ",
            data: [20, 10, 55]
        },
    ]
};

    /*
        const dataStudentTypeA = {
            rows: [
                {
                    type: "นักศึกษาเข้าใหม่",
                    educationLevel: 1,
                    faculty: "ช่างยนต์",
                    industry: "อุตสาหกรรมยานยนต์",
                    count: 45,
                    recruit: 2,
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 1,
                    faculty: "ช่างไฟฟ้า",
                    industry: "อุตสาหกรรมอิเล็กทรอนิกส์",
                    count: 30,
                    recruit: 5,
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 1,
                    faculty: "ช่างไฟฟ้า",
                    industry: "อุตสาหกรรมอิเล็กทรอนิกส์",
                    count: 30,
                    recruit: 4,
                },
                {
                    type: "ผู้สำเร็จการศึกษา",
                    educationLevel: 2,
                    faculty: "เทคโนโลยีสารสนเทศ",
                    industry: "อุตสาหกรรมดิจิทัล",
                    count: 55,
                    recruit: 7,
                }
            ],
            page: 1,
            pageSize: 10,
            totalRows: 6
        };
    */

    /*
        const dataGraduateTypeA = {
        labels: [
            'จำนวนที่ผู้ประกอบการรับเข้าทำงานหลังเรียนจบ',
            'จำนวนที่ไม่ได้รับเข้าทำงาน',
        ],
        datasets: [
            {
            data: [180, 80],
            borderWidth: 1
            }
        ]
        };
    */

const statsData = [
    {
        number: '66',
        label: 'สถานศึกษาที่มีความร่วมมือ',
        color: '#ff9404'
    },
    {
        number: '94,262',
        label: 'จำนวนผู้เรียนทวิภาคีภาครัฐ (2561-2569)',
        color: '#0e3362'
    },
    {
        number: '2,021',
        label: 'สถานประกอบการรับผู้เรียน ทวิภาคีภาครัฐ ปี 2569',
        color: '#6e9bfb'
    }
];

const table1Column = [
    'ลำดับ',
    'ชื่อสถานศึกษา',
    'จังหวัด',
    'ประเภทสถานศึกษา',
    'สาขาวิชา ปวช.',
    'จำนวนสาขา ปวช.',
    'สาขาวิชา ปวส.',
    'จำนวนสาขา ปวส.',
]
const table2Column = [
    'ลำดับ',
    'ชื่อสถานศึกษา',
    'จังหวัด',
    'ประเภทสถานศึกษา',
    'สาขาวิชา ปริญญาตรี',
    'จำนวนสาขา',
]

const vocationalData = {
  updatedAt: "17 สิงหาคม 2569",
  rows: [
    { "ลำดับ": "1", "ชื่อสถานศึกษา": "วิทยาลัยการอาชีพบางปะกง", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "การบัญชี; คอมพิวเตอร์ธุรกิจ; ช่างยนต์; ช่างไฟฟ้า; ธุรกิจค้าปลีก; เมคคาทรอนิกส์และหุ่นยนต์", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "เทคนิคยานยนต์ไฟฟ้า; ไฟฟ้ากำลัง; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; เทคโนโลยีธุรกิจดิจิทัล; การจัดการ; โลจิสติกส์และซัพพลายเชน", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "2", "ชื่อสถานศึกษา": "วิทยาลัยเกษตรและเทคโนโลยีฉะเชิงเทรา", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "เกษตรศาสตร์; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวช.": "2", "สาขาวิชา ปวส.": "พืชศาสตร์; สัตวศาสตร์; เกษตรศาสตร์; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "3", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคจุฬาภรณ์ (ลาดขวาง)", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างเชื่อมโลหะ; ช่างซ่อมบำรุง; ช่างกลโรงงาน; อิเล็กทรอนิกส์; ช่างไฟฟ้า; ช่างยนต์; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "อิเล็กทรอนิกส์; เทคนิคการผลิต; เทคนิคอุตสาหกรรม; เทคนิคเครื่องกล; เทคนิคโลหะ; เทคโนโลยีธุรกิจดิจิทัล; เทคโนโลยีอิเล็กทรอนิกส์; ไฟฟ้า", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "4", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคฉะเชิงเทรา", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ยานยนต์ไฟฟ้า; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้ากำลัง; ช่างอิเล็กทรอนิกส์; ช่างโทรคมนาคม; ช่างก่อสร้าง; เมคคาทรอนิกส์", "จำนวนสาขา ปวช.": "9", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า; เทคนิคการผลิต; เทคนิคอุตสาหกรรม; เทคนิคโลหะ; ไฟฟ้า; อิเล็กทรอนิกส์; เทคโนโลยีโทรคมนาคม; ช่างก่อสร้าง; เมคคาทรอนิกส์และหุ่นยนต์", "จำนวนสาขา ปวส.": "10" },
    { "ลำดับ": "5", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคพนมสารคาม", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้า; อิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; การตลาด; เทคโนโลยีสารสนเทศ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "10", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคการผลิต; เทคนิคโลหะ; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; การจัดการทั่วไป; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวส.": "9" },
    { "ลำดับ": "6", "ชื่อสถานศึกษา": "วิทยาลัยสารพัดช่างฉะเชิงเทรา", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "-", "จำนวนสาขา ปวช.": "", "สาขาวิชา ปวส.": "ไฟฟ้า; เทคนิคเครื่องกล; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "7", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาฉะเชิงเทรา", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; การเลขานุการ; คอมพิวเตอร์ธุรกิจ; ธุรกิจค้าปลีก; แฟชั่นและสิ่งทอ; อาหารและโภชนาการ; คหกรรมศาสตร์; วิจิตรศิลป์; การออกแบบ; คอมพิวเตอร์กราฟิก; โรงแรม", "จำนวนสาขา ปวช.": "12", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; การจัดการโลจิสติกส์และซัพพลายเชน; การจัดการสำนักงาน; เทคโนโลยีแฟชั่นและเครื่องแต่งกาย; อาหารและโภชนาการ; การบริหารงานคหกรรมศาสตร์; ดิจิทัลกราฟิก; โรงแรม; การจัดประชุมและนิทรรศการ; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวส.": "12" },
    { "ลำดับ": "8", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีการจัดการนวัตกรรม", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การโรงแรม; ช่างซ่อมบำรุง; การจัดการสำนักงานดิจิทัล", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "นายประจำเรือฝ่ายเดินเรือ; นายประจำเรือฝ่ายช่างกล", "จำนวนสาขา ปวส.": "2" },
    { "ลำดับ": "9", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีบางปะกงบริหารธุรกิจ", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "10", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยียานยนต์โตโยต้า", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ช่างยนต์", "จำนวนสาขา ปวช.": "1", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า; เทคโนโลยีอุตสาหกรรมตัวถังและสีรถยนต์; การจัดการธุรกิจงานบริการยานยนต์", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "11", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีศรีวรการ", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; เทคโนโลยีธุรกิจดิจิทัล; ธุรกิจค้าปลีก", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "การบัญชี; เทคโนโลยีธุรกิจดิจิทัล; ธุรกิจค้าปลีก", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "12", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอาเซียนไทยบ้านโพธิ์", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ไฟฟ้ากำลัง; ยานยนต์; เครื่องมือกล; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "ไฟฟ้ากำลัง; เทคนิคยานยนต์; เทคโนโลยีวิศวกรรมอุตสาหกรรมการผลิต; ธุรกิจดิจิทัล; การจัดการ", "จำนวนสาขา ปวส.": "5" },
    { "ลำดับ": "13", "ชื่อสถานศึกษา": "วิทยาลัยการอาชีพพนัสนิคม", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างเชื่อมโลหะ; ช่างกลโรงงาน; ช่างไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; โลจิสติกส์", "จำนวนสาขา ปวช.": "8", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคการผลิต; ไฟฟ้า; เมคคาทรอนิกส์และหุ่นยนต์; เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; การจัดการโลจิสติกส์และซัพพลายเชน", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "14", "ชื่อสถานศึกษา": "วิทยาลัยเกษตรและเทคโนโลยีชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "การผลิตพืช; การผลิตสัตว์; ช่างเกษตร; อุตสาหกรรมเกษตร; ประมง; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "พืชศาสตร์; สัตวศาสตร์; ช่างกลเกษตร; เทคโนโลยีการจัดการธุรกิจเกษตร; เพาะเลี้ยงสัตว์น้ำ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "15", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้ากำลัง; ช่างอิเล็กทรอนิกส์; ช่างก่อสร้าง; สถาปัตยกรรม; เมคคาทรอนิกส์; ยานยนต์ไฟฟ้า; ช่างเทคนิคคอมพิวเตอร์; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวช.": "11", "สาขาวิชา ปวส.": "ทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า; เทคนิคการผลิต; เทคนิคโลหะ; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; ช่างก่อสร้าง; เทคนิคสถาปัตยกรรม; เทคนิคอุตสาหกรรม; เมคคาทรอนิกส์; ระบบขนส่งทางราง; การจัดการโลจิสติกส์และซัพพลายเชน; เทคโนโลยีสารสนเทศ; เทคโนโลยีคอมพิวเตอร์", "จำนวนสาขา ปวส.": "14" },
    { "ลำดับ": "16", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคบางแสน", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ยานยนต์ไฟฟ้า; ช่างเชื่อมโลหะ; ช่างไฟฟ้า; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; การโรงแรม", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า; ไฟฟ้า; เมคคาทรอนิกส์และหุ่นยนต์; การจัดการสำนักงานดิจิทัล; การโรงแรม", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "17", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคพัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ตัวถังและสีรถยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้า; อิเล็กทรอนิกส์; เมคคาทรอนิกส์; การบัญชี; การตลาด; การโรงแรม; การท่องเที่ยว; โลจิสติกส์; อาหารและโภชนาการ; ช่างเทคนิคคอมพิวเตอร์; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "15", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคโนโลยีอุตสาหกรรมตัวถังและสีรถยนต์; เทคนิคโลหะการ; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; การตลาด; การโรงแรม; การท่องเที่ยว; การจัดการโลจิสติกส์และซัพพลายเชน; เทคโนโลยีคอมพิวเตอร์; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "13" },
    { "ลำดับ": "18", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคสัตหีบ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างเขียนแบบเครื่องกล; ช่างไฟฟ้า; อิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างก่อสร้าง; การบัญชี; การโรงแรม; การท่องเที่ยว; ช่างเทคนิคคอมพิวเตอร์; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวช.": "13", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า; เทคนิคการผลิต; เทคนิคโลหะ; เขียนแบบเครื่องกล; การตรวจสอบโดยไม่ทำลาย; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างก่อสร้าง; เครื่องมือวัดและควบคุม; การบัญชี; การจัดการธุรกิจค้าปลีก; การโรงแรม; การท่องเที่ยว; การจัดการโลจิสติกส์และซัพพลายเชน; ระบบขนส่งทางราง; ธุรกิจการบิน; ช่างอากาศยาน; เทคโนโลยีสารสนเทศ; เครือข่ายคอมพิวเตอร์และความปลอดภัย", "จำนวนสาขา ปวส.": "21" },
    { "ลำดับ": "19", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "การจัดการสำนักงาน; การจัดประชุมและนิทรรศการ; การตลาด; การบัญชี; การออกแบบ; การโรงแรม; คหกรรม; ดิจิทัลกราฟิก; ท่องเที่ยว; ธุรกิจคหกรรม; ธุรกิจค้าปลีก; บริหารธุรกิจ; วิจิตรศิลป์; ศิลปกรรมและเศรษฐกิจสร้างสรรค์; สามัญศึกษา; สามัญสัมพันธ์; อาหารและโภชนาการ; อุตสาหกรรมดิจิทัลและ IT; อุตสาหกรรมท่องเที่ยว; อุตสาหกรรมอาหาร; อุตสาหกรรมแฟชั่นและสิ่งทอ; อุตสาหกรรมโลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล; เทคโนโลยีสารสนเทศ; แฟชั่นและสิ่งทอ; โลจิสติกส์", "จำนวนสาขา ปวช.": "26", "สาขาวิชา ปวส.": "การจัดการสำนักงาน; การจัดประชุมและนิทรรศการ; การตลาด; การบัญชี; การออกแบบ; การโรงแรม; คหกรรม; ดิจิทัลกราฟิก; ท่องเที่ยว; ธุรกิจคหกรรม; ธุรกิจค้าปลีก; บริหารธุรกิจ; วิจิตรศิลป์; ศิลปกรรมและเศรษฐกิจสร้างสรรค์; สามัญศึกษา; สามัญสัมพันธ์; อาหารและโภชนาการ; อุตสาหกรรมดิจิทัลและ IT; อุตสาหกรรมท่องเที่ยว; อุตสาหกรรมอาหาร; อุตสาหกรรมแฟชั่นและสิ่งทอ; อุตสาหกรรมโลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล; เทคโนโลยีสารสนเทศ; แฟชั่นและสิ่งทอ; โลจิสติกส์", "จำนวนสาขา ปวส.": "26" },
    { "ลำดับ": "20", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาเทคโนโลยีฐานวิทยาศาสตร์ (ชลบุรี)", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างอุตสาหกรรม; พาณิชยกรรม", "จำนวนสาขา ปวช.": "2", "สาขาวิชา ปวส.": "เครื่องกล; ไฟฟ้ากำลัง; อิเล็กทรอนิกส์; เมคคาทรอนิกส์; ช่างกลโรงงาน; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "21", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีจอมเทียนบริหารธุรกิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การตลาด; การบัญชี; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "การตลาด; การบัญชี; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "22", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; ธุรกิจค้าปลีก; ภาษาต่างประเทศธุรกิจ; ช่างยนต์; ช่างไฟฟ้า; ยานยนต์ไฟฟ้า; เมคคาทรอนิกส์และหุ่นยนต์; อิเล็กทรอนิกส์; โลจิสติกส์; การท่องเที่ยว; เทคโนโลยีธุรกิจดิจิทัล; ภาษาต่างประเทศธุรกิจบริการ; ภาษาและการจัดการธุรกิจระหว่างประเทศ", "จำนวนสาขา ปวช.": "14", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; ธุรกิจค้าปลีก; ไฟฟ้า; เทคนิคเครื่องกล; เมคคาทรอนิกส์และหุ่นยนต์; เทคนิคยานยนต์ไฟฟ้า; การจัดการโลจิสติกส์และซัพพลายเชน; การท่องเที่ยว; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวส.": "10" },
    { "ลำดับ": "23", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีชลบุรีบริหารธุรกิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; การจัดการธุรกิจค้าปลีก; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "24", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีชลพินิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; ดิจิทัลกราฟิก; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; ดิจิทัลกราฟิก; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "25", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีทางทะเลแห่งเอเชีย", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ภาษาต่างประเทศ; โลจิสติกส์", "จำนวนสาขา ปวช.": "2", "สาขาวิชา ปวส.": "การจัดการโลจิสติกส์; การโรงแรมและการบริการบนเรือสำราญ", "จำนวนสาขา ปวส.": "2" },
    { "ลำดับ": "26", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีไทยอิโตะ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; ภาษาต่างประเทศ; คอมพิวเตอร์ธุรกิจ; เทคนิคช่างยานยนต์; ช่างไฟฟ้า; การโรงแรม", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; ภาษาต่างประเทศ; คอมพิวเตอร์ธุรกิจ; เทคนิคช่างยานยนต์; ช่างไฟฟ้า; การโรงแรม", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "27", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีบางละมุงอินเตอร์-เทค", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ไฟฟ้ากำลัง; อิเล็กทรอนิกส์; เทคนิคคอมพิวเตอร์; คอมพิวเตอร์; การบัญชี; การตลาด; การโรงแรม", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "การจัดการโลจิสติกส์และซัพพลายเชน; ไฟฟ้ากำลัง; อิเล็กทรอนิกส์; เทคโนโลยีคอมพิวเตอร์; เทคโนโลยีธุรกิจดิจิทัล; การจัดการ; การบัญชี; การตลาด; การโรงแรม", "จำนวนสาขา ปวส.": "9" },
    { "ลำดับ": "28", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีพระมหาไถ่ พัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "เทคโนโลยีธุรกิจดิจิทัล; เทคโนโลยีสารสนเทศ", "จำนวนสาขา ปวช.": "2", "สาขาวิชา ปวส.": "เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "1" },
    { "ลำดับ": "29", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีพัทยาบริหารธุรกิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "30", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีพัทยาพณิชยการ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "0" },
    { "ลำดับ": "31", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีภาคตะวันออก (อี.เทค)", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; ช่างยนต์; ช่างไฟฟ้ากำลัง; ช่างอิเล็กทรอนิกส์; ช่างกลโรงงาน; เมคคาทรอนิกส์", "จำนวนสาขา ปวช.": "14", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; ดิจิทัลมีเดีย; ธุรกิจดิจิทัล; ธุรกิจอีคอมเมิร์ซ; เทคโนโลยีสารสนเทศ; การจัดการทรัพยากรมนุษย์; เทคนิคยานยนต์; เทคนิคยานยนต์ไฟฟ้า; ไฟฟ้ากำลัง; อิเล็กทรอนิกส์อุตสาหกรรม; เมคคาทรอนิกส์และหุ่นยนต์; คอมพิวเตอร์ฮาร์ดแวร์; เทคโนโลยีวิศวกรรมอุตสาหกรรมการผลิต; ก่อสร้าง", "จำนวนสาขา ปวส.": "15" },
    { "ลำดับ": "32", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีเมืองชลบริหารธุรกิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; โลจิสติกส์; ดิจิทัลกราฟิก", "จำนวนสาขา ปวช.": "5", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; การจัดการโลจิสติกส์และซัพพลายเชน; ดิจิทัลกราฟิก", "จำนวนสาขา ปวส.": "5" },
    { "ลำดับ": "33", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีเมืองชลพณิชยการ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; โลจิสติกส์; ดิจิทัลกราฟิก; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "5", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; การจัดการโลจิสติกส์; ดิจิทัลกราฟิก; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "5" },
    { "ลำดับ": "34", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีวิศวกรรม บริหารธุรกิจ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ช่างยนต์; ไฟฟ้ากำลัง; การตลาด; การบัญชี; คอมพิวเตอร์กราฟิก; โลจิสติกส์", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "ช่างยนต์; ไฟฟ้ากำลัง; การตลาด; การบัญชี; คอมพิวเตอร์กราฟิก; โลจิสติกส์", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "35", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีวิศวกรรมแหลมฉบัง", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างไฟฟ้า; ช่างอิเล็กทรอนิกส์; เมคคาทรอนิกส์; การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; ไฟฟ้า; เทคนิคอุตสาหกรรม; การจัดการธุรกิจการกีฬา; เมคคาทรอนิกส์และหุ่นยนต์; การบัญชี; การตลาด; การจัดการโลจิสติกส์; เทคโนโลยีสารสนเทศ; มัลติมีเดีย; การจัดการงานบริการสถานพยาบาล; เทคนิคยานยนต์ไฟฟ้า", "จำนวนสาขา ปวส.": "12" },
    { "ลำดับ": "36", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีศรีราชา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; โลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล; ช่างยนต์; ช่างไฟฟ้า", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; การจัดการโลจิสติกส์และซัพพลายเชน; เทคโนโลยีธุรกิจดิจิทัล; เทคนิคเครื่องกล; ไฟฟ้ากำลัง", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "37", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีสว่างบริบูรณ์ พัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; เทคโนโลยีธุรกิจดิจิทัล; ภาษาต่างประเทศธุรกิจบริการ; การจัดการงานบริการสถานพยาบาล; โลจิสติกส์; การโรงแรม; การจัดการโรงแรม", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "การบัญชี; เทคโนโลยีธุรกิจดิจิทัล; ภาษาต่างประเทศธุรกิจบริการ; การจัดการงานบริการสถานพยาบาล; โลจิสติกส์; การโรงแรม; การจัดการโรงแรม", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "38", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอักษรบางละมุง", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "เทคโนโลยีธุรกิจดิจิทัล; โลจิสติกส์; การบัญชี; การโรงแรม; ช่างยนต์; ช่างไฟฟ้า", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "ไม่มีผู้เรียนในระดับนี้", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "39", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอักษรพัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; การโรงแรม; การจัดการโลจิสติกส์; ช่างยนต์; ช่างไฟฟ้ากำลัง", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; การโรงแรม; การจัดการโลจิสติกส์และซัพพลายเชน; เทคนิคเครื่องกล (เทคนิคยานยนต์และเทคนิคยานยนต์ไฟฟ้า); ช่างไฟฟ้า", "จำนวนสาขา ปวส.": "7" },
    { "ลำดับ": "40", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอีอีซี เอ็นจิเนีย แหลมฉบัง", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "เทคโนโลยีธุรกิจดิจิทัล; การจัดการโลจิสติกส์; ดิจิทัลกราฟิก; การบัญชี; ช่างยนต์; ช่างกลโรงงาน; เมคคาทรอนิกส์; ไฟฟ้ากำลัง", "จำนวนสาขา ปวช.": "8", "สาขาวิชา ปวส.": "เทคโนโลยีธุรกิจดิจิทัล; การจัดการโลจิสติกส์; ดิจิทัลกราฟิก; การบัญชี; ช่างยนต์; ช่างกลโรงงาน; เมคคาทรอนิกส์; ไฟฟ้ากำลัง", "จำนวนสาขา ปวส.": "8" },
    { "ลำดับ": "41", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาคิงส์ตัน พัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ไม่พบผู้เรียนในระดับนี้", "จำนวนสาขา ปวช.": "0", "สาขาวิชา ปวส.": "การจัดการธุรกิจ", "จำนวนสาขา ปวส.": "1" },
    { "ลำดับ": "42", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาเทคนิคบริหารธุรกิจกรุงเทพชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; การโรงแรม; การท่องเที่ยว; โลจิสติกส์", "จำนวนสาขา ปวช.": "6", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; คอมพิวเตอร์ธุรกิจ; การจัดการทั่วไป; การจัดการโลจิสติกส์; การโรงแรม", "จำนวนสาขา ปวส.": "6" },
    { "ลำดับ": "43", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาพณิชยการชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; ธุรกิจค้าปลีก", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; ธุรกิจค้าปลีก", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "44", "ชื่อสถานศึกษา": "วิทยาลัยดุสิตธานี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "ป. ตรี การจัดการโรงแรม ศิลปะการประกอบอาหาร เทคโนโลยีอาหารและการประกอบอาหารสร้างสรรค์", "จำนวนสาขา ปวช.": "", "สาขาวิชา ปวส.": "", "จำนวนสาขา ปวส.": "" },
    { "ลำดับ": "45", "ชื่อสถานศึกษา": "วิทยาลัยการอาชีพแกลง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างไฟฟ้ากำลัง; เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; ช่างอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างกลโรงงาน; การโรงแรม; ช่างเทคนิคอุตสาหกรรม; การจัดการทั่วไป", "จำนวนสาขา ปวช.": "10", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างกลโรงงาน; การโรงแรม; ช่างเทคนิคอุตสาหกรรม; การจัดการทั่วไป", "จำนวนสาขา ปวส.": "8" },
    { "ลำดับ": "46", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคนิคมอุตสาหกรรมระยอง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "เทคโนโลยีสารสนเทศ; การบัญชี; การตลาด; ช่างกลโรงงาน; ช่างไฟฟ้ากำลัง; ช่างยนต์; ช่างเชื่อมโลหะ; ช่างเทคนิคคอมพิวเตอร์; ช่างเมคคาทรอนิกส์และโครงการ; การโรงแรม", "จำนวนสาขา ปวช.": "10", "สาขาวิชา ปวส.": "เทคโนโลยีสารสนเทศ; การบัญชี; การตลาด; ช่างกลโรงงาน; ช่างไฟฟ้ากำลัง; ช่างยนต์; ช่างเชื่อมโลหะ; ช่างเทคนิคคอมพิวเตอร์; ช่างเมคคาทรอนิกส์และโครงการ; การโรงแรม", "จำนวนสาขา ปวส.": "10" },
    { "ลำดับ": "47", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคบ้านค่าย", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างซ่อมบำรุง; ช่างเชื่อมโลหะ; ไฟฟ้า; อิเล็กทรอนิกส์; ช่างก่อสร้าง; การบัญชี; ธุรกิจค้าปลีก; การโรงแรม; โลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "12", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคการผลิต; เทคนิคอุตสาหกรรม; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างก่อสร้าง; การบัญชี; การตลาด; การโรงแรม; การจัดการโลจิสติกส์และซัพพลายเชน; เทคนิคเครื่องกล; เทคนิคการผลิต; เทคนิคอุตสาหกรรม; ไฟฟ้า; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างก่อสร้าง; การบัญชี; การตลาด; การโรงแรม; การจัดการโลจิสติกส์และซัพพลายเชน; เทคนิคเครื่องกลเรือ; เทคโนโลยีสารสนเทศ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "14" },
    { "ลำดับ": "48", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคมาบตาพุด", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้า; อิเล็กทรอนิกส์; เทคโนโลยีสารสนเทศ; เทคโนโลยีปัญญาประดิษฐ์", "จำนวนสาขา ปวช.": "7", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคยานยนต์ไฟฟ้า (EV); เทคนิคการผลิต; เทคนิคโลหะ; ไฟฟ้า; เครื่องมือวัดและควบคุม; เทคนิคพลังงาน; เทคโนโลยีสารสนเทศ; ปิโตรเคมี (V-ChEPC); ไฟฟ้า (V-EsEPC); ปิโตรเคมี ไทย–จีน (V-TCEPC)", "จำนวนสาขา ปวส.": "11" },
    { "ลำดับ": "49", "ชื่อสถานศึกษา": "วิทยาลัยเทคนิคระยอง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปวช.": "ช่างยนต์; ช่างกลโรงงาน; ช่างเชื่อมโลหะ; ช่างไฟฟ้ากำลัง; ช่างอิเล็กทรอนิกส์; ช่างก่อสร้าง; เมคคาทรอนิกส์; การบัญชี; การตลาด; การจัดการสำนักงาน; คอมพิวเตอร์ธุรกิจ; อาหารและโภชนาการ; การโรงแรม; การท่องเที่ยว; เทคโนโลยีสารสนเทศ; สถาปัตยกรรม", "จำนวนสาขา ปวช.": "16", "สาขาวิชา ปวส.": "เทคนิคเครื่องกล; เทคนิคการผลิต; เทคนิคโลหะ; ไฟฟ้า; อิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; ช่างก่อสร้าง; เครื่องมือวัดและควบคุม; การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; การจัดการโลจิสติกส์และซัพพลายเชน; อาหารและโภชนาการ; การโรงแรม; การท่องเที่ยว; เทคโนโลยีสารสนเทศ; เทคนิคยานยนต์ไฟฟ้า", "จำนวนสาขา ปวส.": "17" },
    { "ลำดับ": "50", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีพัฒนเวช", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "โลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; ภาษาต่างประเทศธุรกิจและบริการ", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "โลจิสติกส์; เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; ภาษาต่างประเทศธุรกิจและบริการ", "จำนวนสาขา ปวส.": "4" },
    { "ลำดับ": "51", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีระยองบริหารธุรกิจ", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; การตลาด; การจัดการโลจิสติกส์; ภาษาต่างประเทศ", "จำนวนสาขา ปวช.": "5", "สาขาวิชา ปวส.": "เทคโนโลยีธุรกิจดิจิทัล; การบัญชี; การตลาด; การจัดการโลจิสติกส์; ภาษาต่างประเทศ", "จำนวนสาขา ปวส.": "5" },
    { "ลำดับ": "52", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอักษรบริหารธุรกิจ", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; คอมพิวเตอร์ธุรกิจ; โลจิสติกส์", "จำนวนสาขา ปวช.": "3", "สาขาวิชา ปวส.": "การจัดการโลจิสติกส์และซัพพลายเชน; การบัญชี; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "53", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีอาเซียนบริหารธุรกิจ", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การตลาด; การบัญชี; การโรงแรม; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล", "จำนวนสาขา ปวช.": "5", "สาขาวิชา ปวส.": "คอมพิวเตอร์ธุรกิจ; การบัญชี; การโรงแรม", "จำนวนสาขา ปวส.": "3" },
    { "ลำดับ": "54", "ชื่อสถานศึกษา": "วิทยาลัยเทคโนโลยีไออาร์พีซี", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; โลจิสติกส์", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "เทคโนโลยีธุรกิจดิจิทัล; เทคโนโลยีอิเล็กทรอนิกส์; เมคคาทรอนิกส์และหุ่นยนต์; เทคนิคยานยนต์ไฟฟ้า; เทคนิคเครื่องกล; เทคนิคการผลิต; เคมีอุตสาหกรรม; เทคนิคพลังงาน; ปิโตรเคมี; ไฟฟ้า; การบัญชี", "จำนวนสาขา ปวส.": "11" },
    { "ลำดับ": "55", "ชื่อสถานศึกษา": "วิทยาลัยอาชีวศึกษาโปลีเทคนิคระยอง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปวช.": "การตลาด; การบัญชี; คอมพิวเตอร์ธุรกิจ; เทคโนโลยีธุรกิจดิจิทัล; โลจิสติกส์", "จำนวนสาขา ปวช.": "4", "สาขาวิชา ปวส.": "การบัญชี; การตลาด; เทคโนโลยีธุรกิจดิจิทัล; โลจิสติกส์และซัพพลายเชน", "จำนวนสาขา ปวส.": "4" },
  ],
};

const bachelorData = {
  updatedAt: "17 สิงหาคม 2569",
  rows: [
    { "ลำดับ": "1", "ชื่อสถานศึกษา": "มหาวิทยาลัยราชภัฏราชนครินทร์", "จังหวัด": "ฉะเชิงเทรา", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "การศึกษาปฐมวัย; การประถมศึกษา; ภาษาไทย; ภาษาอังกฤษ; ภาษาจีน; สังคมศึกษา; คอมพิวเตอร์ศึกษา; วิทยาศาสตร์ทั่วไป; คณิตศาสตร์; การสอนภาษาไทย; รัฐศาสตร์; รัฐประศาสนศาสตร์; นิติศาสตร์; ภาษาอังกฤษเพื่อการสื่อสารสากล; ภาษาจีนเพื่อการสื่อสาร; การพัฒนาสังคม; ดนตรีสากล; ทัศนศิลป์และมีเดียอาร์ต; การบัญชี; การจัดการ; การตลาด; คอมพิวเตอร์ธุรกิจ; การท่องเที่ยวและการโรงแรม; เทคโนโลยีดิจิทัล; วิทยาการคอมพิวเตอร์; เทคโนโลยีสารสนเทศ; สาธารณสุขศาสตร์; อาชีวอนามัยและความปลอดภัย; เทคโนโลยีการเกษตร; วิทยาศาสตร์และเทคโนโลยีการอาหาร; วิศวกรรมการจัดการอุตสาหกรรม; วิศวกรรมไฟฟ้า; วิศวกรรมเครื่องกล; พยาบาลศาสตร์", "จำนวนสาขา": "34" },
    { "ลำดับ": "2", "ชื่อสถานศึกษา": "มหาวิทยาลัยบูรพา วิทยาเขตบางแสน", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "พยาบาลศาสตร์; นิเทศศาสตร์; จิตวิทยา; ภูมิศาสตร์และภูมิสารสนเทศศาสตร์; การจัดการทรัพยากรวัฒนธรรม; การจัดการบริการสังคม; ประวัติศาสตร์; ภาษาจีนเพื่อการสื่อสาร; ภาษาญี่ปุ่นเพื่อการสื่อสารธุรกิจสากล; ภาษาฝรั่งเศสเพื่อการสื่อสาร; ภาษาอังกฤษเพื่อการสื่อสาร; ภาษาเกาหลี; ภาษาไทย; ศาสนาและปรัชญา; สารสนเทศศึกษา; เศรษฐศาสตร์; คณิตศาสตร์; จุลชีววิทยา; ชีววิทยา; ชีวเคมี; ฟิสิกส์และเทคโนโลยี; วาริชศาสตร์; วิทยาการข้อมูลและการวิเคราะห์ข้อมูล; วิทยาศาสตร์เชิงสร้างสรรค์และนวัตกรรม; วิทยาศาสตร์และเทคโนโลยีอาหาร; สถิติประยุกต์และการจัดการข้อมูล; เคมี; เทคโนโลยีชีวภาพและสิ่งแวดล้อม; การศึกษาปฐมวัย; ฟิสิกส์ศึกษา; เคมีศึกษา; การประถมศึกษา จิตวิทยาและการแนะแนว; คณิตศาสตร์ศึกษา; ชีววิทยาศึกษา; พลศึกษา; ภาษาจีนศึกษา; ศิลปศึกษา; สังคมศึกษา; เทคโนโลยีดิจิทัลเพื่อการศึกษาและคอมพิวเตอร์ศึกษา; เทคโนโลยีอุตสาหกรรมศึกษา; การบัญชี; การจัดการ; การตลาด; การเงิน; ธุรกิจระหว่างประเทศ; การจัดการโลจิสติกส์และโซ่อุปทาน; การท่องเที่ยวและการโรงแรม; วิทยาการคอมพิวเตอร์; เทคโนโลยีสารสนเทศ; วิศวกรรมเคมี; วิศวกรรมเครื่องกล; วิศวกรรมไฟฟ้า; วิศวกรรมโยธา; วิศวกรรมวัสดุ; วิศวกรรมสิ่งแวดล้อม; วิศวกรรมหุ่นยนต์และระบบอัตโนมัติ; วิศวกรรมอุตสาหการ; สาธารณสุขชุมชน; สุขศาสตร์อุตสาหกรรมและความปลอดภัย; เทคนิคการแพทย์; พยาธิวิทยากายวิภาค; วิทยาศาสตร์การแพทย์; โภชนาการและการกำหนดอาหาร; การแพทย์แผนไทยประยุกต์; กายภาพบำบัด; วิทยาศาสตร์การออกกำลังกายและการกีฬา; ศิลปกรรม; ดนตรีและการแสดง; การออกแบบผลิตภัณฑ์; รัฐศาสตร์; นิติศาสตร์; แพทยศาสตร์; เภสัชศาสตร์", "จำนวนสาขา": "72" },
    { "ลำดับ": "3", "ชื่อสถานศึกษา": "มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตศรีราชา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "เศรษฐศาสตร์; การจัดการ; การตลาดดิจิทัลและการสร้างตรา; ธุรกิจระหว่างประเทศ; การจัดการโลจิสติกส์; การเงินและการลงทุน; การบัญชี; การจัดการโรงแรมและท่องเที่ยว; วิทยาศาสตร์การเดินเรือ; การขนส่งทางทะเล; วิศวกรรมต่อเรือและวิศวกรรมสมุทรศาสตร์; วิศวกรรมเครื่องกลเรือ; วิทยาการคอมพิวเตอร์; เทคโนโลยีสารสนเทศ; วิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม; เคมี; คณิตศาสตร์ประยุกต์; ฟิสิกส์; วิศวกรรมคอมพิวเตอร์และสารสนเทศศาสตร์; วิศวกรรมเครื่องกลและการออกแบบ; วิศวกรรมไฟฟ้าและอิเล็กทรอนิกส์; วิศวกรรมอุตสาหการและระบบ; วิศวกรรมโยธา", "จำนวนสาขา": "23" },
    { "ลำดับ": "4", "ชื่อสถานศึกษา": "มหาวิทยาลัยเทคโนโลยีราชมงคลตะวันออก เขตพื้นที่บางพระ", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "เกษตรกลวิธาน; เทคโนโลยีภูมิทัศน์; พืชศาสตร์; สัตวศาสตร์; ประมง; วิทยาศาสตร์สุขภาพสัตว์; สัตวแพทยศาสตร์; วิทยาการคอมพิวเตอร์; เทคโนโลยีสารสนเทศและการสื่อสาร; วิทยาศาสตร์และเทคโนโลยีการอาหาร; เทคโนโลยีการประกอบอาหารและการบริการ; ผลิตภัณฑ์เพื่อสุขภาพและความงาม; วิศวกรรมเกษตร; วิศวกรรมเมคคาทรอนิกส์และหุ่นยนต์; วิศวกรรมเครื่องกล; วิศวกรรมไฟฟ้า; วิศวกรรมโยธา; การบัญชี; การจัดการ; การตลาด; โลจิสติกส์และการจัดการระบบขนส่ง; เทคโนโลยีธุรกิจดิจิทัล; การท่องเที่ยวและการบริการ", "จำนวนสาขา": "23" },
    { "ลำดับ": "5", "ชื่อสถานศึกษา": "มหาวิทยาลัยธรรมศาสตร์ ศูนย์พัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "วิศวกรรมยานยนต์; วิศวกรรมซอฟต์แวร์; วิศวกรรมอุตสาหการ; วิศวกรรมไฟฟ้า; วิศวกรรมเครื่องกล; วิศวกรรมโยธา; เทคโนโลยีดิจิทัลและนวัตกรรม; การออกแบบเชิงนวัตกรรมดิจิทัล", "จำนวนสาขา": "8" },
    { "ลำดับ": "6", "ชื่อสถานศึกษา": "มหาวิทยาลัยศรีปทุม วิทยาเขตชลบุรี", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปริญญาตรี": "การจัดการธุรกิจด้านการบิน; การตลาดดิจิทัล; การบริหารและการจัดการสมัยใหม่; ธุรกิจระหว่างประเทศ; การจัดการโลจิสติกส์และโซ่อุปทาน; การบัญชี; เทคโนโลยีสารสนเทศและการสื่อสาร; วิทยาการคอมพิวเตอร์และนวัตกรรมการพัฒนาซอฟต์แวร์; นิเทศศาสตร์; การออกแบบสื่อดิจิทัล; นิติศาสตร์; รัฐประศาสนศาสตร์; การจัดการการท่องเที่ยวและไมซ์; การจัดการโรงแรม; วิศวกรรมโลจิสติกส์; วิศวกรรมอุตสาหการและการจัดการ; วิศวกรรมไฟฟ้า; ภาษาจีนสื่อสารธุรกิจ; ภาษาอังกฤษสื่อสารธุรกิจ", "จำนวนสาขา": "19" },
    { "ลำดับ": "7", "ชื่อสถานศึกษา": "สถาบันการจัดการปัญญาภิวัฒน์ วิทยาเขต EEC", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปริญญาตรี": "วิศวกรรมหุ่นยนต์และระบบอัตโนมัติ; วิศวกรรมดิจิทัลและสารสนเทศ; วิศวกรรมการผลิตยานยนต์; การจัดการธุรกิจการค้าสมัยใหม่; การจัดการโลจิสติกส์และการคมนาคมขนส่ง; การจัดการธุรกิจอาหาร; การจัดการบริการและการท่องเที่ยว", "จำนวนสาขา": "7" },
    { "ลำดับ": "8", "ชื่อสถานศึกษา": "วิทยาลัยดุสิตธานี ศูนย์การศึกษาเมืองพัทยา", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปริญญาตรี": "การจัดการโรงแรม; ศิลปะการประกอบอาหารและการจัดการครัว; การจัดการรีสอร์ต; การจัดการการท่องเที่ยว; การจัดการไมซ์และอีเวนต์", "จำนวนสาขา": "5" },
    { "ลำดับ": "9", "ชื่อสถานศึกษา": "วิทยาลัยการสาธารณสุขสิรินธร จังหวัดชลบุรี สถาบันพระบรมราชชนก", "จังหวัด": "ชลบุรี", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "สาธารณสุขชุมชน; ทันตสาธารณสุข; การแพทย์แผนไทย; เวชระเบียน; ปฏิบัติการฉุกเฉินการแพทย์", "จำนวนสาขา": "5" },
    { "ลำดับ": "10", "ชื่อสถานศึกษา": "มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ วิทยาเขตระยอง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "รัฐ", "สาขาวิชา ปริญญาตรี": "วิศวกรรมเครื่องกลและยานยนต์; วิศวกรรมไฟฟ้าและระบบอัตโนมัติ; วิศวกรรมเคมีและกระบวนการ; วิศวกรรมวัสดุและกระบวนการผลิต; วิศวกรรมอุตสาหการและโลจิสติกส์; เทคโนโลยีพลังงานและการจัดการธุรกิจอุตสาหกรรมในยุคดิจิทัล; กระบวนการอุตสาหกรรมเคมีและสิ่งแวดล้อม; เทคโนโลยีวิศวกรรมกระบวนการเคมี; การบัญชี; คอมพิวเตอร์ธุรกิจ; บริหารธุรกิจอุตสาหกรรมและโลจิสติกส์; การจัดการธุรกิจระหว่างประเทศ", "จำนวนสาขา": "12" },
    { "ลำดับ": "11", "ชื่อสถานศึกษา": "มหาวิทยาลัยเฉลิมกาญจนา ศูนย์ระยอง", "จังหวัด": "ระยอง", "ประเภทสถานศึกษา": "เอกชน", "สาขาวิชา ปริญญาตรี": "พยาบาลศาสตร์; สาธารณสุขชุมชน", "จำนวนสาขา": "2" },
  ],
};
   
const currentYears = new Date().getFullYear();

class Dashboard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Masterbase: {},
            Token: {
                Expired: false
            },
            filter: {
                typeAYears: '',
                matchingYears: {
                    type: 'select',
                    id: 'years',
                    label: 'ปี',
                    value: String(currentYears+543),
                    placeholder: 'ปี',
                },
            }
        };
        this.updateState = this.setState.bind(this);
    }

    loadMasterbase = async () => {
        let filter = this.state.filter
        let sets = [
            { key: "dashboard_section_a_budget_request", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },
            { key: "dashboard_section_a_academy_success", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },
            { key: "dashboard_section_a_industries_budget", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },            
            { key: "dashboard_section_a_industries_success", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },

            { key: "dashboard_section_b_trained_course", filter: [] },
            { key: "dashboard_section_b_not_trained_course", filter: [] },

            { key: "dashboard_eb_user_training_by_months", filter: [] },
            { key: "dashboard_eb_training_summary_info", filter: [] },
            { key: "dashboard_eb_budget_summary_industries", filter: [] },
            { key: "dashboard_eb_01_info", filter: [] },
            { key: "dashboard_eb_02_info", filter: [] },

            { key: "dashboard_enterprise_location_info", filter: [] },
            { key: "dashboard_enterprise_province_summary", filter: [] },

            { key: "dashboard_users_overall", filter: [] },
            // { key: "dashboard_users_in_detail", filter: [] },

            { key: "dashboard_type_a_100_table", filter: [] },
            { key: "dashboard_type_a_dual_table", filter: [] },
            { key: "dashboard_academy_line", filter: [] },
            { key: "dashboard_academy_province", filter: [] },
            { key: "dashboard_type_a_line", filter: [] },
            { key: "dashboard_type_a_percentage", filter: [] },
            { key: "dashboard_type_a_enterprise_chart", filter: [] },
            { key: "dashboard_matching_chart", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },
            { key: "dashboard_matching_table", filter: [{field: filter.matchingYears.id, value: filter.matchingYears.value}] },
        ];

        await Actions.loadMasterbase(this.updateState, sets);
    }

    initialize = async () => {
        await this.loadMasterbase();
    }

    componentDidMount = async () => {
        this.props.toggleCollapsedNav(false);
        await this.initialize();
    }

    setFilterValue = (key, value) => {
      this.setState(prevState => ({
        filter: {
          ...prevState.filter,
          [key]: {
            ...prevState.filter[key],
            value
          }
        }
      }), () => {
        this.loadMasterbase()
    });
    };

    StatCard = ({ title, detail }) => {
        return (
            <Card className='text-center p-2'>
                <div className='p-3'>
                    <h5>
                        {title}
                    </h5>
                    <span>{detail}</span>
                </div>
            </Card>
        )
    }

    render = () => {

        let Masterbase = this.state.Masterbase;

        let { Token, filter } = this.state;

        let {
            dashboard_section_a_budget_request = [],
            dashboard_section_a_academy_success = [],
            dashboard_section_a_industries_budget = [],
            dashboard_section_a_industries_success = [],
            dashboard_section_b_trained_course = [],
            dashboard_section_b_not_trained_course = [],

            dashboard_eb_user_training_by_months = [],
            dashboard_eb_training_summary_info = [],
            dashboard_eb_budget_summary_industries = [],
            dashboard_eb_01_info = [],
            dashboard_eb_02_info = [],
            dashboard_enterprise_location_info = [],
            dashboard_enterprise_province_summary = [],
            dashboard_users_overall = [],
            // dashboard_users_in_detail = [],
            dashboard_type_a_100_table = [],
            dashboard_type_a_dual_table = [],
            dashboard_academy_line = [],
            dashboard_academy_province = [],
            dashboard_type_a_line = [],
            dashboard_type_a_percentage = [],
            dashboard_type_a_enterprise_chart = [],
            dashboard_matching_chart = [],
            dashboard_matching_table = [],
        } = Masterbase;        

        let dashboard_section_a_budget_request_doughnut_charts = charts.academyTopBudgetDoughnutChart(dashboard_section_a_budget_request);
        let dashboard_section_a_budget_request_charts = charts.budgetRequestChart(dashboard_section_a_budget_request);
        let dashboard_section_a_budget_request_data = charts.budgetRequestData(dashboard_section_a_budget_request)

        let dashboard_section_a_academy_success_doughnut_charts = charts.academyTopTraineeResultDoughnutChart(dashboard_section_a_academy_success);
        let dashboard_section_a_academy_success_charts = charts.traineeResultChart(dashboard_section_a_academy_success);
        let dashboard_section_a_academy_success_data = charts.traineeResultData(dashboard_section_a_academy_success);

        let dashboard_section_a_industries_budget_charts = charts.budgetByIndustriesChart(dashboard_section_a_industries_budget);
        let dashboard_section_a_industries_budget_data = charts.budgetByIndustriesData(dashboard_section_a_industries_budget);

        let dashboard_section_a_industries_success_charts = charts.traineeResultByIndustryChart(dashboard_section_a_industries_success);
        let dashboard_section_a_industries_success_data = charts.traineeResultByIndustryData(dashboard_section_a_industries_success);

        let dashboard_section_b_trained_course_data = charts.trainedCourseData( dashboard_section_b_trained_course);
        let dashboard_section_b_not_trained_course_data = charts.notTrainedCourseData( dashboard_section_b_not_trained_course);

        let dashboard_eb_user_training_by_months_data = charts.ebUserTrainingByMonth(dashboard_eb_user_training_by_months);

        let dashboard_eb_user_training_by_industries_data = charts.ebUserTrainingByIndustries(dashboard_eb_user_training_by_months);

        let dashboard_eb_training_summary_info_data = charts.summarizeTrainingInfo(dashboard_eb_training_summary_info);

        let dashboard_eb_budget_summary_industries_info_data = charts.summarizeBudgetByIndustriesInfo(dashboard_eb_budget_summary_industries);

        let dashboard_eb_budget_summary_industries_data = charts.summarizeBudgetByIndustries(dashboard_eb_budget_summary_industries);

        // let dashboard_users_overall_summary_data = charts.summarizeUsersOverall(dashboard_users_overall);

        // let dashboard_users_in_details_data = charts.usersInDetailsChartData(dashboard_users_in_detail);

        let dashboard_eb_01_info_data = charts.eb01Info(dashboard_eb_01_info);

        let dashboard_eb_02_info_data = charts.eb02Info(dashboard_eb_02_info);

        let dashboard_type_a_100_table_data = charts.typeA100TableData(dashboard_type_a_100_table);

        let dashboard_type_a_dual_table_data = charts.typeADualTableData(dashboard_type_a_dual_table);

        let dashboard_academy_line_data = charts.academyChartData(dashboard_academy_line)

        let dashboard_academy_summary_data = charts.latestYearAcademyChartData(dashboard_academy_line)

        let dashboard_academy_summary_text = [charts.growthTotal(dashboard_academy_line_data), charts.growthPercent(dashboard_academy_line_data)];

        let dashboard_academy_province_data = charts.academyEnumerate(dashboard_academy_province)

        let dashboard_type_a_line_data = charts.typeAData(dashboard_type_a_line)

        let dashboard_type_a_summary_text = `${charts.growthTotal(dashboard_type_a_line_data, "คน")} ${charts.growthPercent(dashboard_type_a_line_data)}`;

        let dashboard_type_a_count = charts.countTypeAByType(dashboard_type_a_line_data)

        let dashboard_type_a_percentage_data = charts.typeADataTable(dashboard_type_a_percentage)

        let dashboard_type_a_enterprise_chart_data = charts.typeAEnterpriseData(dashboard_type_a_enterprise_chart)

        let dashboard_type_a_enterprise_chart_datatable = charts.typeAEnterpriseDataTable(dashboard_type_a_enterprise_chart)

        let dashboard_matching_chart_data = charts.matchingData(dashboard_matching_chart)
        
        let dashboard_matching_table_data = charts.matchingDataTable(dashboard_matching_table)

        return (
            <>
                <Container>

                    <CommonTokenExpired Token={Token} />

                    <div className="hk-pg-header pg-header-with-tab pt-7">
                        <div className="d-flex">
                            <div className="d-flex flex-wrap justify-content-between flex-1">
                                <div className="mb-lg-0 mb-2 me-8">
                                    <Figure>
                                        <h4>ยินดีต้อนรับสู่ EEC มีงานทำ</h4>
                                        <figcaption className="blockquote-footer mt-2">EECmeengantam.eeco.or.th - Back Office System</figcaption>
                                    </Figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hk-pg-body">
                        <Row className="g-4">
                            {statsData.map((item, index) => (
                                <Col md={4} key={index}>
                                    <Card 
                                        className="text-center border-0 shadow-sm h-100" 
                                        style={{ 
                                            borderRadius: '16px',
                                            backgroundColor: item.color,
                                            color: '#fff'
                                        }}
                                    >
                                        <Card.Body className="py-4">
                                            <div style={{ fontSize: '2.5rem', fontWeight: 700 }}>
                                                {item.number}
                                            </div>
                                            <div style={{ fontSize: '0.95rem', opacity: 0.9, marginTop: '8px' }}>
                                                {item.label}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Table 1 */}
                        <Row className='mt-5'>
                            <Col className='mt-5'>
                                <Figure>
                                    <h4 className='fw-bold'>ข้อมูลหลักสูตรและสาขาวิชาเพื่อการพัฒนากำลังคนในอุตสาหกรรมเป้าหมาย พื้นที่ EEC</h4>
                                    <h5 >ข้อมูลสถานศึกษาและสาขาวิชาระดับ ปวช. และ ปวส. (ข้อมูลปรับปรุงเมื่อวันที่ 17 สิงหาคม 2569)</h5>
                                </Figure>
                            </Col>
                        </Row>
                        <div className='p-4'>
                            <DataTableDashboardCustom
                                data={vocationalData}
                                columnName={table1Column}
                                cardWrap={false}
                                colorOpacityWithValue={true}
                                maxHeight='640px'
                                rowStyle={{ backgroundColor: '#FAFAFA', color: 'gray' }}
                            />
                        </div>

                        {/* Table 2 */}
                        <Row className='mt-5'>
                            <Col>
                                <Figure>
                                    <h5 >ข้อมูลสถานศึกษาและสาขาวิชาระดับปริญญาตรี (ข้อมูลปรับปรุงเมื่อวันที่ 17 สิงหาคม 2569)</h5>
                                </Figure>
                            </Col>
                        </Row>
                        <div className='p-4'>
                            <DataTableDashboardCustom
                                data={bachelorData}
                                columnName={table2Column}
                                cardWrap={false}
                                colorOpacityWithValue={false}
                                maxHeight='640px'
                                rowStyle={{ backgroundColor: '#FAFAFA', color: 'gray' }}
                            />
                        </div>

                        {/* section 1 */}
                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4 style={{ color: '#2f5496', fontWeight: 'bold' }}>ข้อมูลนักศึกษาทวิภาคี</h4>
                                    <h5>นักศึกษาทวิภาคี เข้าใหม่-สำเร็จการศึกษา ปี 2561 - 2569</h5>
                                </Figure>
                            </Col>
                        </Row>

                        <Row>

                            <Col xxl={12} lg={12} md={12} className="mb-md-4 p-4">
                                <DashboardMultiLineChart
                                    title="จำนวนสถานศึกษาในพื้นที่ EEC (แห่ง)"
                                    icon="fa-solid fa-chart-line"
                                    bg="primary"
                                    chartData={dashboard_type_a_line_data}
                                    cardWrap={false}
                                    datalabels
                                />
                            </Col>

                        </Row>

                        <Row className=''>
                            <Col>
                                <Figure>
                                    <h5 style={{ color: '#2f5496', fontWeight: 'bold' }}>ข้อมูลผู้สำเร็จการศึกษาทวิภาคี ปี 2562 – 2568 แยกตามอุตสาหกรรม</h5>
                                </Figure>
                            </Col>
                        </Row>

                        <div className='p-4'>
                            <DataTableDashboardCustom
                                data={dashboard_type_a_percentage_data}
                                columnName={dashboard_type_a_percentage_data.columnName}
                                cardWrap={false}
                                colorOpacityWithValue={true}
                            />
                        </div>

                        {/* section 2 */}
                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4 className='fw-bold'>EEC Model Type B</h4>
                                </Figure>
                            </Col>
                        </Row>

                        <Row>
                            <Col xxl={9} lg={8} md={7} className="mb-md-4 mb-3">
                                <DashboardBarChartHorizontal
                                    title="เสนอหลักสูตร จำแนกตามอุตสาหกรรม"
                                    icon='fa-classic fa-light fa-right-to-bracket fa-fw'
                                    chartData={dashboard_eb_01_info_data.barChart}
                                    legend={false}
                                    bg="primary"
                                    unit="หลักสูตร"
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardPieChart
                                    title='เสนอหลักสูตร'
                                    icon='fa-classic fa-light fa-grid-2-plus fa-fw'
                                    chartData={dashboard_eb_01_info_data.pieChart}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                    unit="หลักสูตร"
                                />
                            </Col>
                        </Row>

                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ข้อมูลงบประมาณที่สถาบันการศึกษาขอการสนับสนุน</h4>
                                </Figure>
                            </Col>
                            
                            <Col sm={3}>
                                <CommonSelect
                                    element="Inputs"
                                    input={filter.matchingYears}
                                    option={{source: 'db', data: Masterbase?.yearBEOptionsPrevious}}
                                    size="sm"
                                    hr={false}
                                    floatingLabel={false}
                                    callback={(e, element) => this.setFilterValue('matchingYears', e.target.value)}
                                />
                            </Col>
                        </Row>
                            
                        <Row>                                
                            <Col xxl={4} lg={6} md={6} className="mb-md-4 p-4">
                                <DashboardDoughnutChart
                                    key={dashboard_section_a_budget_request_doughnut_charts}
                                    title='ภาพรวม'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    chartData={dashboard_section_a_budget_request_doughnut_charts}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                    customText={"Top 10 สถานศึกษา"}
                                    cardWrap={false}
                                    chartHeight = {300}
                                />
                            </Col>

                            <Col xxl={8} lg={6} md={6} className="mb-md-4 p-4">
                                <DashboardVerticalBarChart
                                    data={dashboard_section_a_budget_request_charts}
                                    cardWrap={false}
                                    stacked={true}
                                    suggestedMaxY={0}
                                    chartHeight = {300}
                                />
                            </Col>
                        </Row>

                        <div className='p-4'>                               
                                <DataTableDashboardSecABudget
                                    title='ตารางงบประมาณที่สถาบันการศึกษาขอการสนับสนุน'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    data={dashboard_section_a_budget_request_data}
                                    bg="primary"
                                />
                        </div>

                        <Row>
                            <Col xxl={9} lg={8} md={7} className="mb-md-4 mb-3">
                                <DashboardBarChartHorizontal
                                    title="ขออนุมัติจัดอบรม รายอุตสาหกรรม"
                                    icon='fa-classic fa-light fa-inbox-in fa-fw'
                                    chartData={dashboard_eb_02_info_data.barChart}
                                    legend={false}
                                    bg="primary"
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardPieChart
                                    title='ขออนุมัติจัดอบรม'
                                    icon='fa-classic fa-light fa-chalkboard-user fa-fw'
                                    chartData={dashboard_eb_02_info_data.pieChart}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                />
                            </Col>
                        </Row>

                        <Row className="mt-0">
                            <Col xxl={9} lg={8} md={7} className="mb-md-4">
                                <DashboardGroupHorizontalBarChart
                                    title='งบประมาณที่ขอ EEC สนันสนุน จำแนกตามอุตสาหกรรม'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    data={dashboard_eb_budget_summary_industries_info_data}
                                    bg="primary"
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardPieChart
                                    title='ภาพรวมงบประมาณ'
                                    icon='fa-classic fa-light fa-coins fa-fw'
                                    chartData={dashboard_eb_budget_summary_industries_data}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                    unit="บาท"
                                />
                            </Col>
                        </Row>

                        <div className='p-4'>                               
                            <DataTableDashboardSecABudgetIndustries
                                title='ตารางงบประมาณของแต่ละหลักสูตร'
                                icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                data={dashboard_section_a_industries_budget_data}
                                bg="primary"
                            />
                        </div>

                        <Row className="mt-0">
                            <Col xxl={9} lg={8} md={7} className="mb-md-4">
                                <DashboardMultiLineChart 
                                    title="จำนวนผู้เข้าอบรมรายเดือนจำแนกตามอุตสาหกรรม"
                                    icon="fa-classic fa-regular fa-person-chalkboard fa-fw"
                                    chartData={dashboard_eb_user_training_by_months_data}
                                    bg="primary"
                                />                   
                                <div className="flex-grow-1 ms-lg-0">
                                    <hr></hr>
                                    <Row>
                                        <Col xxl={3} sm={6} className="mb-3">
                                            <DashboardInfoSummaryBox 
                                                infoLabel="จำนวนผู้เข้าอบรม" 
                                                number="ผู้เข้าอบรม" 
                                                variant="primary" 
                                                value={dashboard_eb_training_summary_info_data.user_training_amount} 
                                            />
                                        </Col>
                                        <Col xxl={3} sm={6} className="mb-3">
                                            <DashboardInfoSummaryBox 
                                                infoLabel="จำนวนหลักสูตร" 
                                                number="หลักสูตร" 
                                                variant="primary" 
                                                value={dashboard_eb_training_summary_info_data.course_amount} 
                                            />
                                        </Col>
                                        <Col xxl={3} sm={6} className="mb-3">
                                            <DashboardInfoSummaryBox 
                                                infoLabel="จำนวนอุตสาหกรรม" 
                                                number="อุตสาหกรรม" 
                                                variant="primary" 
                                                value={dashboard_eb_training_summary_info_data.industries_amount} 
                                            />
                                        </Col>
                                        <Col xxl={3} sm={6} className="mb-3">
                                            <DashboardInfoSummaryBox 
                                                infoLabel="งบประมาณที่ขอ EEC สนันสนุน" 
                                                number="งบประมาณ" 
                                                variant="success" 
                                                value={dashboard_eb_training_summary_info_data.budget_amount} 
                                            />
                                        </Col>
                                    </Row>
                                </div>                                            
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">                         
                                <DashboardPieChart
                                    title='ภาพรวมผู้เข้าอบรม'
                                    icon='fa-classic fa-light fa-screen-users fa-fw'
                                    chartData={dashboard_eb_user_training_by_industries_data}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                />                         
                            </Col>
                        </Row>

                        <Row>
                            <Col xxl={12} lg={12} md={12} className="mb-md-4 p-4">
                                <DashboardVerticalBarChart
                                    title='ผลการดำเนินงานของแต่ละอุตสาหกรรม'
                                    data={dashboard_section_a_industries_success_charts}
                                    cardWrap={true}
                                    stacked={true}
                                    suggestedMaxY={0}
                                    chartHeight = {250}
                                />
                            </Col>
                        </Row>
                        
                        <div className='p-4'>                               
                                <DataTableDashboardSecAIndustries
                                    title='ตารางผลการดำเนินงานของแต่ละอุตสาหกรรม'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    data={dashboard_section_a_industries_success_data}
                                    bg="primary"
                                />
                        </div>

                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ผลการดำเนินงานของแต่ละสถาบันการศึกษา</h4>
                                </Figure>
                            </Col>
                        </Row>
                            
                        <Row>                                
                            <Col xxl={4} lg={6} md={6} className="mb-md-4 p-4">
                                <DashboardDoughnutChart
                                    key={dashboard_section_a_academy_success_doughnut_charts}
                                    title='ภาพรวม'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    chartData={dashboard_section_a_academy_success_doughnut_charts}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                    customText={"Top 10 สถานศึกษา"}
                                    cardWrap={false}
                                    chartHeight = {300}
                                />
                            </Col>
                            <Col xxl={8} lg={6} md={6} className="mb-md-4 p-4">
                                <DashboardVerticalBarChart
                                    data={dashboard_section_a_academy_success_charts}
                                    cardWrap={false}
                                    stacked={true}
                                    suggestedMaxY={0}
                                    chartHeight = {300}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col md={7}>
                                    <div className='p-4' >
                                            <DataTableDashboardSecBCourseList
                                                title='ผลการดำเนินงานหลักสูตรที่ผ่านการอบรม'
                                                icon='fa-classic fa-regular fa-circle-check fa-fw'
                                                data={dashboard_section_b_trained_course_data}
                                                bg="primary"
                                                type="trained"
                                            />
                                    </div>
                            </Col>
                            <Col md={5}>
                                <div className='p-4'>
                                        <DataTableDashboardSecBCourseList
                                            title='หลักสูตรที่ยังไม่มีการอบรม'
                                            icon='fa-classic fa-regular fa-circle-xmark fa-fw'
                                            data={dashboard_section_b_not_trained_course_data}
                                            bg="primary"
                                        />
                                </div>  
                            </Col>                          
                        </Row>

                            {/* <div className='p-4'>                               
                                    <DataTableDashboardSecATrainee
                                        title='ตารางผลการดำเนินงานของแต่ละสถาบันการศึกษา'
                                        icon='fa-classic fa-regular fa-list fa-fw'
                                        data={dashboard_section_a_academy_success_data}
                                        bg="primary"
                                    />
                            </div> */}
                            
                            
                            {/* <Row>
                                <Col xxl={12} lg={12} md={12} className="mb-md-4 p-4">
                                    <DashboardVerticalBarChart
                                        title='งบประมาณที่ใช้ของแต่ละหลักสูตร'
                                        data={dashboard_section_a_industries_budget_charts}
                                        cardWrap={true}
                                        stacked={true}
                                        suggestedMaxY={0}
                                        chartHeight = {250}
                                    />
                                </Col>
                            </Row> */}

                        {/* <Row>
                            <Col xxl={9} lg={8} md={7} className="mb-md-4 mb-3">
                                <DashboardGoogleMap mapData={dashboard_enterprise_location_info} />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardListGroup
                                    title="ผู้ประกอบการจำแนกตามจังหวัด"
                                    icon="fa-classic fa-light fa-house-building fa-fw"
                                    listData={dashboard_enterprise_province_summary}
                                    bg="info"
                                />
                            </Col>
                        </Row> */}

                        {/* <Row>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardSummaryInfo
                                    title='ผู้ประกอบการ'
                                    icon='fa-classic fa-light fa-house-building fa-fw'
                                    value={dashboard_users_overall_summary_data['enterprise']?.total_rows}
                                    variant='success'
                                    action={'จำนวนผู้ประกอบการ ' + dashboard_users_overall_summary_data['enterprise']?.total_rows + ' แห่ง'}
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardSummaryInfo
                                    title='สถานศึกษา'
                                    icon='fa-classic fa-light fa-place-of-worship fa-fw'
                                    value={dashboard_users_overall_summary_data['academy']?.total_rows}
                                    variant='primary'
                                    action={'จำนวนสถานศึกษา ' + dashboard_users_overall_summary_data['academy']?.total_rows + ' แห่ง'}
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardSummaryInfo
                                    title='ผู้ใช้งานภายนอก'
                                    icon='fa-classic fa-light fa-users fa-fw'
                                    value={dashboard_users_overall_summary_data['external_user']?.total_rows}
                                    variant='info'
                                    action={'จำนวนผู้ใช้งานภายนอก ' + dashboard_users_overall_summary_data['external_user']?.total_rows + ' บัญชี'}
                                />
                            </Col>
                            <Col xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                <DashboardSummaryInfo
                                    title='ผู้ใช้งาน'
                                    icon='fa-classic fa-light fa-user-group-simple fa-fw'
                                    value={dashboard_users_overall_summary_data['users']?.total_rows}
                                    variant='warning'
                                    action={'จำนวนผู้ใช้งาน ' + dashboard_users_overall_summary_data['users']?.total_rows + ' บัญชี'}
                                />
                            </Col>
                        </Row> */}

                        {/* <Row className="mt-3">
                            {Object.entries(usersTypesMap).map(([typeKey, { label, icon }]) => {
                                const rawData = dashboard_users_in_details_data?.[typeKey] || {};
                                const { labels = [], data = [] } = rawData;

                                const chartData = {
                                    labels,
                                    datasets: [
                                        {
                                            data
                                        }
                                    ]
                                };

                                return (
                                    <Col key={typeKey} xxl={3} lg={4} md={5} className="mb-md-4 mb-3">
                                        <DashboardPieChart
                                            title={label}
                                            icon={icon}
                                            types={typeKey}
                                            chartData={chartData}
                                            legend={true}
                                            bg={typeKey === '1' ? 'success' : typeKey === '2' ? 'primary' : typeKey === '3' ? 'info' : 'warning'}
                                        />
                                    </Col>
                                );
                            })}
                        </Row> */}

                    </div>

                </Container>
            </>
        )
    }
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}

export default connect(mapStateToProps, { toggleCollapsedNav })(Dashboard);